import api from './api';

export const getQuizDatasets = async () => {
  const response = await api.get('/quiz/datasets');
  return response.data;
};

export const getQuizTopics = async (datasetId) => {
  const response = await api.get('/quiz/topics', { params: { dataset_id: datasetId } });
  return response.data;
};

export const getQuizQuestions = async ({ datasetId, topic, interactionType, limit = 1000, includeAnswers = false }) => {
  const response = await api.get('/quiz/questions', {
    params: {
      dataset_id: datasetId,
      topic: topic || undefined,
      interaction_type: interactionType || undefined,
      limit,
      include_answers: includeAnswers ? true : undefined,
    },
  });
  return response.data;
};

export const gradeQuestion = async (questionId, answer) => {
  const response = await api.post('/quiz/grade', {
    question_id: questionId,
    answer,
  });
  return response.data;
};

export const getLearningSummary = async () => (
  await api.get('/quiz/learning-summary')
).data;

export const getReviewQuestions = async ({ datasetId, topic, state = 'weak', marked, limit = 20 } = {}) => (
  await api.get('/quiz/review-questions', {
    params: {
      dataset_id: datasetId || undefined,
      topic: topic || undefined,
      state,
      marked: marked === undefined ? undefined : marked,
      limit,
    },
  })
).data;

export const getLearningProgress = async (period = '30d') => (
  await api.get('/quiz/progress', { params: { period } })
).data;

export const submitExam = async ({ datasetId, answers, durationSeconds, passPercent = 70, mode = 'exam' }) => {
  const response = await api.post('/quiz/exam-attempts/submit', {
    dataset_id: datasetId,
    answers,
    duration_seconds: durationSeconds,
    pass_percent: passPercent,
    mode,
  });
  return response.data;
};

export const resolveQuizImageUrl = (imageUrl) => {
  const baseURL = api.defaults.baseURL || '';
  if (!imageUrl) return '';
  const token = localStorage.getItem('token');
  const sep = imageUrl.includes('?') ? '&' : '?';
  return token ? `${baseURL}${imageUrl}${sep}token=${encodeURIComponent(token)}` : `${baseURL}${imageUrl}`;
};
